export enum TicketStatus {
  OPEN = 'open',
  CLOSED = 'closed',
}

export enum SupportType {
  GENERAL = 'general',
  FILE = 'file',
  EVC = 'evc',
}

export interface TicketType {
  Id: number;
  ticketTitle: string;
  ticketDescription: string;
  Status: string;
  Label: string;
  thumb: string;
  AgentName: string;
  Date: Date;
  deleted: boolean;
}

export interface ApiTicketCustomer {
  companyName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  creditsAmount?: number | null;
  customerTypeId?: string | null;
  customerTypeName?: string | null;
  slaveSerialNumber?: string | null;
}

export interface ApiTicket {
  id: string;
  shortId?: string | null;
  status: TicketStatus;
  supportType: string;
  subject: string;
  message: string;
  fileUrl?: string | null;
  fileOriginalName?: string | null;
  createdAt: string;
  updatedAt: string;
  customer?: ApiTicketCustomer | null;
}

export interface TicketsMeta {
  total: number;
  closed: number;
  opened: number;
}

export interface TicketsResponse {
  tickets: ApiTicket[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  meta?: TicketsMeta;
}

export interface TicketMessage {
  id: string;
  message: string;
  fileUrl?: string;
  fileOriginalName?: string;
  sender: string;
  createdAt: string;
}
